/**
 * trwcookieconsent Module Entry Point
 *
 * Import styles and JS, expose functions globally for OXID frontend usage.
 */

// Import styles first
import '../scss/trwcookieconsent.scss';

// Import all exports from the main module
import * as TRWCookieConsent from '../js/trwcookieconsent.js';

// Expose all functions globally on window object
if (typeof window !== 'undefined') {
    // Expose each function individually
    Object.keys(TRWCookieConsent).forEach(key => {
        window[key] = TRWCookieConsent[key];
    });
}
